declare global {
  interface Window {
    _tfa?: Array<{ notify: string; name: string; id: number }>;
  }
}
export const taboolaTrackStartCheckout = () => {
  if (window._tfa && Array.isArray(window._tfa)) {
    window._tfa.push({
      notify: 'event',
      name: 'start_checkout',
      id: 1_625_839,
    });
  }
};
